import {
  GetGrupoUsuariosDominioQueryQuery,
  GrupoUsuariosInput
} from '@/core/types/graphql'
import { GrupoUsuariosValues } from '../hooks/use-form'

export const isUsuarioDialogEnabled = (
  possuiUsuariosManuais: boolean,
  possuiPerfil: boolean,
  possuiCargos: boolean,
  possuiSetores: boolean,
  possuiGrupos: boolean,
  errors: object
) => {
  const possuiAlgumGrupoPreenchido =
    possuiUsuariosManuais ||
    possuiPerfil ||
    possuiCargos ||
    possuiSetores ||
    possuiGrupos

  if (!possuiAlgumGrupoPreenchido) {
    return false
  }

  if (Object.entries(errors).length === 0) {
    return true
  }

  const possuiErroSomenteNomeRequired =
    Object.entries(errors).length === 1 &&
    Object.prototype.hasOwnProperty.call(errors, 'nome')

  if (possuiErroSomenteNomeRequired) {
    return true
  }

  const errosPermitidos = [
    'nome',
    'cargos',
    'setores',
    'usuariosManuais',
    'marcas',
    'tiposUsuarios',
    'dealers'
  ]
  const temApenasErrosPermitidos = Object.keys(errors).every(erro =>
    errosPermitidos.includes(erro)
  )

  return temApenasErrosPermitidos
}

export const formatGroup = ({
  grupoUsuarios,
  usuarioLogado
}: {
  grupoUsuarios: GrupoUsuariosValues
  usuarioLogado: GetGrupoUsuariosDominioQueryQuery['usuarioLogado']
}): GrupoUsuariosInput => ({
  active: grupoUsuarios?.active,
  cargos: grupoUsuarios?.cargos?.map(cargo => cargo?.value),
  criador: grupoUsuarios?.criador?.id,
  dealers: grupoUsuarios?.dealers?.map(dealer => dealer?.value),
  grupos: grupoUsuarios?.grupos?.map(grupo => grupo?.value),
  id: grupoUsuarios?.id,
  marcas: grupoUsuarios?.marcas?.map(marca => marca.value),
  nome: grupoUsuarios?.nome,
  publico: grupoUsuarios?.publico,
  setores: grupoUsuarios?.setores?.map(setor => setor?.value),
  tipo: usuarioLogado?.tipo?.id,
  tiposAcesso: grupoUsuarios.tiposAcesso?.map(ta => ta.value),
  tiposUsuarios: grupoUsuarios?.tiposUsuarios?.map(tu => tu.value),
  todosDealers: grupoUsuarios?.todosDealers,
  usuariosManuais: grupoUsuarios?.usuariosManuais?.map(
    usuarioManual => usuarioManual?.value
  )
})
